import { getEnableLegacy, getServicesEnableRaw } from "./servicesEnable.js";

export function isMutual() {
  const email = (sessionStorage.getItem("emailUser") || "")
    .toString()
    .toLowerCase();
  const mutualEmails = [
    "alandrietti@gmail.com",
    "contato@izipaynow.com",
    "abcompagamentos@gmail.com",
    "pedro.neto@arualturismo.com.br",
    "administrativo@kyropaydigital.com",
    "angie.dominguez@pmi.tech",
  ];

  if (mutualEmails.includes(email)) {
    return true;
  }

  const enableLegacy = getEnableLegacy();

  if (enableLegacy === null) {
    const servicesEnableRaw = getServicesEnableRaw();

    // Task 34: `enable_legacy` nunca foi escrita nesta aba — sessão aberta antes do deploy
    // que introduziu a chave (Task 30). Sem esse ramo, cairia no `false` abaixo e um cliente
    // mutual trocaria de endpoint de decode de Pix até a sessão expirar (~30min) ou o login
    // seguinte gravar `enable_legacy`. Escolha: responder uma única vez pela regra que
    // `main` usa hoje — `services_enable` bruto (não a lista normalizada) contendo "BAAS" —
    // em vez de forçar logout, porque é a leitura mais barata e não interrompe a sessão do
    // cliente por causa de um deploy. Não é código morto: o próximo checkSessionExpiration
    // ou login grava `enable_legacy` e este ramo deixa de ser exercitado para essa aba.
    if (servicesEnableRaw !== null) {
      return servicesEnableRaw.toString().toUpperCase().includes("BAAS");
    }

    return false;
  }

  // Task 30: desacoplado de `services_enable` (lista de produtos liberados). A carga de
  // dados desta branch concede BAAS a todos os clientes existentes, então essa chave deixa
  // de distinguir quem é mutual. `enable` legado é o que produzia o comportamento de hoje:
  // mutual só quando o cliente nasceu no produto BAAS (não em "ALL", nem em "RAMPS").
  return enableLegacy.toUpperCase() === "BAAS";
}
